import { Injectable } from '@angular/core';


import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminRoleGuard  {

  constructor(private authService: AuthService) {}

  canActivate(): boolean {
    const user = this.authService.getUser();
    return !!user && user.isAdmin;
  }
}
